import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { BsDaterangepickerConfig } from 'ngx-bootstrap/datepicker';
import { markAllAsDirty, ApiService, toFormData, requiredFileType, requiredFileSize } from 'src/app/_services/api.service';
import { HttpClient } from '@angular/common/http';
import { UntypedFormBuilder, Validators } from '@angular/forms';

@Component({
    selector: 'app-contactCertificate',
    templateUrl: './contactCertificate.component.html',
    styleUrls: ['./contactCertificate.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ContactCertificateComponent implements OnInit {
  progress = 0;
  contactForm: any;
  success = false;
  time: Date = new Date();
  bsConfig: Partial<BsDaterangepickerConfig>;
  reason: boolean= null;
  retire: boolean;
  memoriam: boolean;


  constructor( private http: HttpClient, private formBuilder: UntypedFormBuilder, private apiService: ApiService ) {
    this.bsConfig = Object.assign({}, {
      containerClass: 'theme-dark-blue'
    });
    this.contactForm = this.formBuilder.group({
      eventDate: ['', Validators.required],
      certDate: ['', Validators.required],
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      organization: '',
      direction: '',
      number: '',
      street: '',
      type: '',
      unit: '',
      city: '',
      zipCode: '',
      eventTitle: '',
      reason: ['', Validators.required],
      startDate: '',
      retirementDate: '',
      scroll: '',
      birthDate: '',
      passingDate: '',
      requestorFirstName: '',
      requestorLastName: '',
      requestorOrg: '',
      requestorEmail: ['', Validators.required],
      requestorPhone: ['', Validators.required],
      requestorDirection: '',
      requestorNumber: '',
      requestorStreet: '',
      requestorType: '',
      requestorUnit: '',
      requestorCity: '',
      requestorZipCode: '',
      method: ['', Validators.required],
      deliveryFirstName: ['', Validators.required],
      deliveryLastName: ['', Validators.required],
      deliveryNumber: '',
      deliveryDirection: '',
      deliveryStreet: '',
      deliveryType: '',
      deliveryUnit: '',
      deliveryCity: '',
      deliveryZipCode: '',
      file: ['', [requiredFileType(''), requiredFileSize(10000000)]],
      recaptchaReactive: ['', Validators.required]
    })
  }

  submit() {
    this.success = false;
    console.log(this.contactForm)
    if ( !this.contactForm.valid ) {
      markAllAsDirty(this.contactForm);
      return;
    }


    this.apiService.sendForm(toFormData(this.contactForm.value,),'certificate').subscribe(res => {
      // console.log(res);
      this.progress = 0;
      this.success = true;
      this.contactForm.reset();
      console.log(this.contactForm);
    });

  }

  hasError( field: string, error: string ) {
    const control = this.contactForm.get(field);
    if(this.success)
      return false;
    return control.dirty && control.hasError(error);
  }

  ngOnInit() {
    this.contactForm.get('reason').valueChanges
  .subscribe(value => {
    console.log(value);
    if(value == 'Retirement'){
      this.retire = true;
      this.memoriam = false;
      this.contactForm.get('startDate').setValidators(Validators.required);
      this.contactForm.get('retirementDate').setValidators(Validators.required);
      this.contactForm.get('scroll').setValidators(Validators.required);
      this.contactForm.get('birthDate').clearValidators();
      this.contactForm.get('passingDate').clearValidators();
    }
    else if (value == 'Memoriam') {
      this.retire = false;
      this.memoriam = true;
      this.contactForm.get('startDate').clearValidators();
      this.contactForm.get('retirementDate').clearValidators();
      this.contactForm.get('scroll').clearValidators();
      this.contactForm.get('birthDate').setValidators(Validators.required);
      this.contactForm.get('passingDate').setValidators(Validators.required);
    }
    else {
      this.retire = false;
      this.memoriam = false;
    }
  });
  }

}

export class DemoTimepickerPlaceholderComponent {
  hoursPlaceholder = 'hh';
  minutesPlaceholder = 'mm';
}
